import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17 16a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v7.586l8.293-8.293a1 1 0 1 1 1.414 1.414L9.414 16z",
      clipRule: "evenodd"
    }
  )
);
var SvgDiagonalDownOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DiagonalDownOutlined_default = SvgDiagonalDownOutlined;

export { DiagonalDownOutlined_default as default };
